import React from 'react';
import { ReactComponent as ExclamationTriangle } from 'Icons/Exclamation-Triangle.svg';

function LayersError({ errorText, style = null, id = '' }) {
  return (
    <div
      data-testid={id}
      style={{ width: '100%', overflow: 'auto', ...style }}
      className="flex-y-center"
    >
      <ExclamationTriangle
        id="layerserror-exclamationtriangle"
        style={{ width: '1.5rem', height: '1.375rem' }}
      />
      <label
        id={`layerserror-${errorText}`}
        style={{
          color: '#db0000',
          margin: '0 0 0 0.625rem',
          fontSize: '12px',
          lineHeight: '14px',
        }}
      >
        {errorText}
      </label>
    </div>
  );
}

export default LayersError;
